'use client'

import { first, get } from 'lodash-es'
import AgentEnquiryButton from '../info/agents/enquiryButton'
import AppendRoot from '@component/appendRoot'
import { Suspense } from 'react'

export default function BottomFixedBar({
  data
}) {

  const agent = first(get(data, 'agents', []))
  if (!agent || !data.houseId) return null

  return (
    <AppendRoot>
      <div className='h-72 sm:hidden'>
        <div className='fixed bottom-0 inset-x-0 p-16 bg-white shadow-card z-50'>
          <Suspense>
            <AgentEnquiryButton data={agent} house={data}></AgentEnquiryButton>
          </Suspense>
        </div>
      </div>
    </AppendRoot>
  )
}